import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Alert, Box, DialogActions, DialogContent, Typography } from "@mui/material";

const EmergencyImportDialogReviewStepContent = ({ importData, onClose }) => {
    const handleCloseButtonClick = () => {
        onClose();
    };

    return (
        <>
            <DialogContent sx={{ pt: 3 }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                    <CheckCircleIcon sx={{ fontSize: 64, color: "success.main" }} />
                    <Typography variant="h6" align="center">
                        Import erfolgreich abgeschlossen
                    </Typography>
                    <Alert severity="success" sx={{ width: "100%" }}>
                        <Typography variant="body1">
                            <strong>{importData.results}</strong> Ergebnisse wurden erfolgreich importiert
                        </Typography>
                        {importData.skipped > 0 && (
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                {importData.skipped} Ergebnisse konnten keinem Teilnehmer zugeordnet werden und
                                wurden übersprungen
                            </Typography>
                        )}
                    </Alert>
                </Box>
            </DialogContent>
            <DialogActions>
                <LoadingButton onClick={handleCloseButtonClick} variant="contained">
                    Schließen
                </LoadingButton>
            </DialogActions>
        </>
    );
};

export { EmergencyImportDialogReviewStepContent };